/**
 * Picks v2 or v1 of the Quick Tap edit page based on the redesign flag.
 * Same pattern as the other page switches.
 */
import React from 'react';
import { useRedesignFlag } from '../../../utils/redesignFlag';
import QuickTapsAddEditPage   from './QuickTapsAddEditPage';
import QuickTapsAddEditPageV2 from './QuickTapsAddEditPageV2';

export default function QuickTapsAddEditPageSwitch(props) {
  const [v2] = useRedesignFlag();
  const Component = v2 ? QuickTapsAddEditPageV2 : QuickTapsAddEditPage;
  return <Component {...props} />;
}
